var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconListCheck = function SvgIconListCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.666 10.667H13.333a2.667 2.667 0 0 0-2.667 2.667v41.333a2.667 2.667 0 0 0 2.667 2.667h37.333a2.667 2.667 0 0 0 2.667-2.667V13.334a2.667 2.667 0 0 0-2.667-2.667Z",
    fill: "#15C480"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 6.667H24c-.737 0-1.334.597-1.334 1.333v5.334c0 .736.597 1.333 1.333 1.333h16c.737 0 1.334-.597 1.334-1.333V8c0-.736-.597-1.333-1.334-1.333Z",
    fill: "#239A6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.049 26.78a3.057 3.057 0 1 0 0-6.113 3.057 3.057 0 0 0 0 6.113ZM27.42 33.334h-8.747c-.873 0-1.533-.833-1.287-1.673.713-2.45 2.98-4.094 5.663-4.094 2.684 0 4.947 1.644 5.664 4.094.246.84-.414 1.673-1.287 1.673h-.006Z",
    fill: "#F9F9FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.833 43h-8.334a1.833 1.833 0 0 0 0 3.667h8.334a1.833 1.833 0 0 0 0-3.667Z",
    fill: "#9EEED3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.049 44.113a3.057 3.057 0 1 0 0-6.113 3.057 3.057 0 0 0 0 6.113ZM27.42 50.667h-8.747c-.873 0-1.533-.833-1.287-1.673.713-2.45 2.98-4.094 5.663-4.094 2.684 0 4.947 1.644 5.664 4.094.246.84-.414 1.673-1.287 1.673h-.006Z",
    fill: "#F9F9FA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m41.287 31.344 4.592-5.283a1.833 1.833 0 0 0-2.767-2.405l-4.592 5.283a1.833 1.833 0 1 0 2.767 2.405Z",
    fill: "#9EEED3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.196 28.844 38.13 25.78a1.833 1.833 0 1 0-2.592 2.592l3.064 3.065a1.833 1.833 0 0 0 2.593-2.593Z",
    fill: "#9EEED3"
  })));
};
export default SvgIconListCheck;